import script from "./ProblemCompanyNotesCell.vue?vue&type=script&setup=true&lang=js"
export * from "./ProblemCompanyNotesCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__